import React, { useEffect, useMemo, useState, useContext } from "react";
import { Box, Typography, Grid } from "@mui/material";
import AppAccordion from "../../../components/AppAccordion/AppAccordion";
import faqManagementService from "../../../services/FAQManagementService";
import { useNavigate } from "react-router-dom";
import {
  ERROR_MESSAGE,
  SNACKBAR_VARIANT,
} from "../../../config/Messages.config";
import { useSnackbar } from "../../../contexts/Snackbar.context";
import { AppGlobalContext } from "../../../contexts/AppContext.context";
import { CONTENT_STATUS_CONFIG } from "../../../config/App.config";
import MUILoader from "../../../components/MUILoader/MUILoader";
import PageHeader from "../../../components/PageHeader/PageHeader";
import { AppTheme } from "../../../theme/App.theme";
import MUIButton from "../../../components/MUIButton/MUIButton";

const FAQ = () => {
  const { authUserDetails } = useContext(AppGlobalContext);
  const navigate = useNavigate();
  const { ERROR } = SNACKBAR_VARIANT;
  const { showSnackbar } = useSnackbar();
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  // Function to fetch all FAQs
  const fetchFAQs = async () => {
    try {
      setLoading(true);
      const response = await faqManagementService.getAll({
        page: 1,
        limit: 20,
        language: authUserDetails?.preferredLanguage || "English",
        status: CONTENT_STATUS_CONFIG.PUBLISHED,
      });

      const { data, statusCode } = response;

      if (!data || statusCode !== 200) {
        showSnackbar("Failed to fetch FAQs", ERROR);
        return null;
      }

      setFaqs(data);
    } catch (error) {
      console.error("Error while fetching FAQ:", error.message || error);
      showSnackbar(ERROR_MESSAGE.SOMETHING_WENT_WRONG, ERROR);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!authUserDetails?.uid) return;
    fetchFAQs();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUserDetails]);

  const list = useMemo(
    () =>
      faqs.map((f) => ({
        id: f.id,
        title: f.question,
        content: f.answer,
      })),
    [faqs]
  );

  const handleContactUs = () => {
    navigate("/contact-us")
  }

  return (
    <React.Fragment>
      <PageHeader title={"Frequently Asked Questions"} />
      {loading ? (
        <MUILoader />
      ) : (
        <div>
          <Box sx={{ display: "grid", gap: 1.25 }}>
            {list.map((item, idx) => (
              <AppAccordion
                key={item.id || idx}
                title={item.title}
                defaultExpanded={idx === 0}
              >
                {item.content}
              </AppAccordion>
            ))}
          </Box>

          <Grid container className="mt-3">
            <Grid size={{xs: 12, sm: 5, md: 5, lg: 3}}>
            <div
              className="p-3"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
                backgroundColor: AppTheme.PRIMARY_LIGHT,
                border: `1px solid ${AppTheme.PRIMARY_COLOR}`,
                borderRadius: "12px",
              }}
            >
              <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
                Still have questions?
              </Typography>
              <Typography variant="body2" sx={{ color: AppTheme.SUBTITLE_COLOR }}>
                Our team is here to help you with any questions you may have.
              </Typography>
              <div className="mt-2">
                <MUIButton
                  primary
                  children={"Contact Us"}
                  onClick={handleContactUs}
                />
              </div>
            </div>
            </Grid>
          </Grid>
        </div>
      )}
    </React.Fragment>
  );
};

export default FAQ;
